const link3 = {
  displayField: 'label',
  name: 'link3',
  description: '',
  fields: [
    {
      id: 'label',
      name: 'label test 11',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'shortText',
      name: 'short text',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: { id: 'link3', version: 169, updatedAt: '2023-03-01T01:13:19.569Z' }
};
export default link3;